import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ordenesApi } from '../services/api';
import OrdenForm from '../components/OrdenForm';

const OrdenNueva = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (data) => {
    setLoading(true);
    setError('');
    try {
      const response = await ordenesApi.create(data);
      alert(`Orden #${response.numero_orden} creada exitosamente`);
      navigate(`/ordenes/${response.id}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al crear la orden');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Nueva Orden de Reparación</h1>
          <p className="page-subtitle">Complete el formulario para registrar una nueva orden</p>
        </div>
      </div>

      {error && (
        <div className="alert alert-error">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
          </svg>
          {error}
        </div>
      )}

      <div className="card">
        <OrdenForm onSubmit={handleSubmit} loading={loading} />
      </div>
    </div>
  );
};

export default OrdenNueva;
